export default "__VITE_PUBLIC_ASSET__11335ad0__"